import { baseurl } from "./Constants";

export const SERVICE_UNAVAILABLE_EVENT = "hc:service-unavailable";

let installed = false;

// The services call fetch directly, so there is no shared client to hook a
// status check into. This wraps window.fetch once and raises an event when our
// own API answers 503; ServiceUnavailableWatcher turns that into a redirect.
// The response is handed back untouched, so callers behave exactly as before.
export const installServiceStatusWatcher = () => {
  if (installed || typeof window === "undefined" || typeof window.fetch !== "function") return;
  installed = true;

  const nativeFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);

    if (response.status === 503) {
      const input = args[0];
      const url = typeof input === "string" ? input : input?.url || String(input);
      if (url.startsWith(baseurl)) {
        window.dispatchEvent(new Event(SERVICE_UNAVAILABLE_EVENT));
      }
    }

    return response;
  };
};
